import {initWebComponent} from "@/helpers/web-component-helper";
// import * as bootstrap from "bootstrap";
import {LayerMenuActiveItemComponent} from "@/components/layer/menu/active/layer-menu-active-item-component";
import {
    LayerMenuActiveAddDatasetComponent
} from "@/components/layer/menu/active/layer-menu-active-add-dataset-component";
import {
    LayerMenuActiveItemSwitcherComponent
} from "@/components/layer/menu/active/layer-menu-active-item-switcher-component";
import {
    LayerMenuActiveItemRemoveComponent
} from "@/components/layer/menu/active/layer-menu-active-item-remove-component";
import {LayerMenuActiveItemZoomComponent} from "@/components/layer/menu/active/layer-menu-active-item-zoom-component";
import {
    LayerInfoInfoItemGeometryMeasureAhnComponent
} from "@/components/layer/info/info/layer-info-info-item-geometry-measure-ahn-component";
import {
    LayerInfoInfoItemGeometryMeasureSegmentsComponent
} from "@/components/layer/info/info/layer-info-info-item-geometry-measure-segments-component";
import {
    LayerInfoInfoItemGeometryMeasureBufferComponent
} from "@/components/layer/info/info/layer-info-info-item-geometry-measure-buffer-component";
import {LayerMenuButton3dComponent} from "@/components/layer/menu/button/layer-menu-button-3d-component";
import {
    LayerMenuActiveItemZoomScaleComponent
} from "@/components/layer/menu/active/layer-menu-active-item-zoom--scale-component";
import {hideElementsBySelector} from "@/helpers/element-helper";
import {
    LayerInfoInfoItemGeometryMeasureAhnProfileComponent
} from "@/components/layer/info/info/layer-info-info-item-geometry-measure-ahn-profile-component.js";

const template = document.createElement('template');
template.innerHTML = `
<div class="active-layers">
    <div id="layer-active">
    </div>
    <div id="div-layer-active-temporary" class="d-none"> 
        <h3 class="mt-2 mb-1">Toegevoegde lagen</h3>
        <div id="layer-active-temporary"></div>
    </div>
<!--    <layer-menu-add-dataset-item></layer-menu-add-dataset-item>-->
</div>`;

/**
 * @type {LayerMenuActiveComponent}
 */
export class LayerMenuActiveComponent extends HTMLElement{
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('mouseover', (e) => {
            const button = e.target.querySelector('layer-menu-active-item-remove button')
            if(button) {
                hideElementsBySelector('layer-menu-active-item-remove button')
                button.classList.remove('d-none')
            }
        })
    }
}

window.customElements.define("layer-menu-active-item", LayerMenuActiveItemComponent);
window.customElements.define("layer-info-info-geometry-measure-ahn", LayerInfoInfoItemGeometryMeasureAhnComponent);
window.customElements.define("layer-info-info-geometry-measure-ahn-profile", LayerInfoInfoItemGeometryMeasureAhnProfileComponent);
window.customElements.define("layer-info-info-geometry-measure-buffer", LayerInfoInfoItemGeometryMeasureBufferComponent);
window.customElements.define("layer-info-info-geometry-measure-segments", LayerInfoInfoItemGeometryMeasureSegmentsComponent);
window.customElements.define("layer-menu-active-item-switcher", LayerMenuActiveItemSwitcherComponent);
window.customElements.define("layer-menu-active-item-remove", LayerMenuActiveItemRemoveComponent);
window.customElements.define("layer-menu-active-item-zoom", LayerMenuActiveItemZoomComponent);
window.customElements.define("layer-menu-active-item-zoom-scale", LayerMenuActiveItemZoomScaleComponent);
window.customElements.define("layer-menu-button-3d", LayerMenuButton3dComponent);

window.customElements.define("layer-menu-add-dataset-item", LayerMenuActiveAddDatasetComponent);
